module.exports = __webpack_public_path__ + "static/media/on_form_white.b403a8b1.svg";